import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {
    IAccount,
    AssignedAccountCount,
    IAccountNameList,
    IExportRequest,
    IExternalAccountRequest,
    IExternalAccountExists,
    ICreateExternalAccount,
    IExportFilterDDList,
    AccountName,
    IMultipleAccountEditRequest
} from '@irb/irb-clients/irb-clients.model';

@Injectable({ providedIn: 'root' })
export class AssignedAccountsService {

    httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
          "Pragma": "no-cache",
          "Expires": "Sat, 01 Jan 2000 00:00:00 GMT"
        })
      };

    _filterCriteria: string = '';
    _filterKeys: string = '';
    _sortCriteria: string = '';
    paramsForAcctNum: string;
    paramsForAcctName: string;
    constructor(private readonly http: HttpClient) { }

    getAssignedAccounts(params: any, modelFilterIds: Array<string>, portfolioFilterIds: Array<string>): Observable<HttpResponse<IAccount[]>> {
        const headers = new HttpHeaders({
            'X-HTTP-Method-Override':'GET',
            'Filter-Item':'items=' + params.request.startRow + '-' + (--params.request.endRow)
          });
        let filterKeys = '';

        if (params.request.sortModel.length > 0) {
            const sortColumn = params.request.sortModel[0].colId;
            const sortOrder = (params.request.sortModel[0].sort === 'asc') ? '+' : '-';
            this._sortCriteria = 'sort(' + sortOrder + sortColumn + ')';
        }

        if (params.request.filterModel && params.request.filterModel['accountName']) {
            if (params.request.filterModel['accountName'].values) {
                filterKeys = filterKeys + '%26accountId%3D' + params.request.filterModel['accountName'].values;
            }
        }

        if (params.request.filterModel && params.request.filterModel['accountNumber']) {
            if (params.request.filterModel['accountNumber'].values) {
                filterKeys = filterKeys + '%26accountNumber%3D' + params.request.filterModel['accountNumber'].values;
            }
        }

        if (params.request.filterModel && params.request.filterModel['accountsubType']) {
            if (params.request.filterModel['accountsubType'].values) {
                filterKeys = filterKeys + '%26accountsubType%3D' + params.request.filterModel['accountsubType'].values;
            }
        }

        if (params.request.filterModel && params.request.filterModel['portfolio']) {
            if (params.request.filterModel['portfolio'].values) {
                filterKeys = filterKeys + '%26portfolioId%3D' + portfolioFilterIds;
            }
        }

        if (params.request.filterModel && params.request.filterModel['accountLocationType']) {
            if (params.request.filterModel['accountLocationType'].values) {
                filterKeys = filterKeys + '%26accountLocationType%3D' + params.request.filterModel['accountLocationType'].values;
            }
        }

        if (params.request.filterModel && params.request.filterModel['masterAccount']) {
            if (params.request.filterModel['masterAccount'].values) {
                filterKeys = filterKeys + '%26masterAccount%3D' + params.request.filterModel['masterAccount'].values;
            }
        }
      
        if (params.request.filterModel && params.request.filterModel['modelName']) {
            if (params.request.filterModel['modelName'].values) {
                filterKeys = filterKeys + '%26modelId%3D' + modelFilterIds;
            }
        }

        if (params.request.filterModel && params.request.filterModel['marketValue']) {
            let minvalue = params.request.filterModel['marketValue'].filter;
            let maxvalue = params.request.filterModel['marketValue'].filterTo;
            if ((minvalue || maxvalue) || (minvalue === 0) || (maxvalue === 0)) {
                minvalue = (minvalue === 0) ? 0 : (minvalue ? minvalue : null);
                maxvalue = (maxvalue === 0) ? 0 : (maxvalue ? maxvalue : null);
                const minmaxvalue = minvalue + ',' + maxvalue;
                filterKeys = filterKeys + '%26acctMktValueFilter%3D' + minmaxvalue;
            }
        }

        if (params.request.filterModel && params.request.filterModel['autoCashHoldForDistAmt']) {
            let minvalue = params.request.filterModel['autoCashHoldForDistAmt'].filter;
            let maxvalue = params.request.filterModel['autoCashHoldForDistAmt'].filterTo;
            if ((minvalue || maxvalue) || (minvalue === 0) || (maxvalue === 0)) {
                minvalue = (minvalue === 0) ? 0 : (minvalue ? minvalue : null);
                maxvalue = (maxvalue === 0) ? 0 : (maxvalue ? maxvalue : null);
                const minmaxvalue = minvalue + ',' + maxvalue;
                filterKeys = filterKeys + '%26autoCashHoldForDistAmt%3D' + minmaxvalue;
            }
        }

        // if (params.request.filterModel && params.request.filterModel['custodian']) {
        //     let selectedCust = [];
        //     if (params.request.filterModel['custodian'].values) {
        //     const selectedCustIds = params.request.filterModel['custodian'].values;
        //         if (selectedCustIds && selectedCustIds.length) {
        //             for (const record of selectedCustIds) {
        //                 if (record == "TD AMERITRADE") {
        //                     selectedCust.push("null");
        //                 }
        //                 else {
        //                     selectedCust.push(record);
        //                 }
        //             }
        //         }
        //         filterKeys = filterKeys + '%26custodian%3D' + selectedCust;
        //     }
        // }

        if (filterKeys) {
            this._filterCriteria = '&Filter=' + filterKeys;
            this._filterKeys = filterKeys;
        } else {
            this._filterCriteria = '';  
            this._filterKeys = '';  
        }

        return this.http.post<IAccount[]>('irebalone/accounts/acc-inv/?' + this._sortCriteria,{Filter:filterKeys},
            { headers: headers, observe: 'response' })
            .pipe(delay(1000), tap(_res => {
                //console.log(res.headers.get("Content-Range"));
            })
        );
    }

    getMultieditSelection(params: any, multipleAccountEditRequest: IMultipleAccountEditRequest) {
        let sort = '';
        let filterKeys = '';
        
        const headers = new HttpHeaders({
            'Filter-Item':'items=' + params.request.startRow + '-' + (--params.request.endRow)
        });

        if (params.request.sortModel.length > 0) {
            let sortColumn = params.request.sortModel[0].colId;
            const sortOrder = (params.request.sortModel[0].sort === 'asc') ? '+' : '-';
            sort = 'sort(' + sortOrder + sortColumn + ')';
        }

        if (params.request.filterModel && params.request.filterModel['accountName']) {
            if (params.request.filterModel['accountName'].values) {
                filterKeys = filterKeys + '%26accountId%3D' + params.request.filterModel['accountName'].values;
            }
        }

        if (params.request.filterModel && params.request.filterModel['accountsubType']) {
            if (params.request.filterModel['accountsubType'].values) {
                filterKeys = filterKeys + '%26accountsubType%3D' + params.request.filterModel['accountsubType'].values;
            }
        }
        
        if (params.request.filterModel && params.request.filterModel['marketValue']) {
            let minvalue = params.request.filterModel['marketValue'].filter;
            let maxvalue = params.request.filterModel['marketValue'].filterTo;
            if ((minvalue || maxvalue) || (minvalue === 0) || (maxvalue === 0)) {
                minvalue = (minvalue === 0) ? 0 : (minvalue ? minvalue : null);
                maxvalue = (maxvalue === 0) ? 0 : (maxvalue ? maxvalue : null);
                const minmaxvalue = minvalue + ',' + maxvalue;
                filterKeys = filterKeys + '%26acctMktValueFilter%3D' + minmaxvalue;
            }
        }

        multipleAccountEditRequest.filter = filterKeys;
        return this.http.post<IAccount[]>('/irebalone/accounts/get-multiedit-selection?' + sort, multipleAccountEditRequest, {headers: headers});
        
        /*let d: any = [];
        let a: any = ["A", "B", "C", "X","Y","Z"];
    
        for(let i = 0; i < 50; i++) {
            let c = Math.floor(Math.random() * a.length);
            let v = Math.floor(Math.random() * 999);
            let h = Math.floor(Math.random() * a.length);
    
            d.push({
                accountNumber: i,
                accountName: "Account " + a[c] + " " + i,
                marketValue: v,
                accountsubType: "TYPE " + a[h]
            });
        }
    
        return of(d);*/
    }

    getAssignedAccountCount(): Observable<AssignedAccountCount> {
        return this.http.get<AssignedAccountCount>('irebalone/accounts/get-assigned-account-count').pipe(delay(1000));
    }

    getComboDropDownValues(params: any): Observable<string[]> {
        return this.http.get<string[]>('/irebalone/accounts/assigned-account-values' + '/' + encodeURI(params)).pipe(delay(1000));
    }

    getAccountNameDropDownValues(params: any): Observable<IAccountNameList> {
        return this.http.get<IAccountNameList>('/irebalone/accounts/account-names' + '/' + encodeURI(params)).pipe(delay(1000));
    }

    getAssignedAccountNumber(): Observable<AccountName[]> {
        return this.http.get<AccountName[]>('/irebalone/accounts/assigned-account-number' + '/' + encodeURI(this.paramsForAcctNum)).pipe(delay(1000));
    }

    getAssignedAccountName(): Observable<any> {
        let url = '/irebalone/accounts/assigned-account-name';
        return this.http.get<any>(url + '?s=' + encodeURI(this.paramsForAcctName)).pipe(delay(1000));
    }

    getModelNameDropDownValues(): Observable<any> {
        return this.http.get<IExportFilterDDList>('/irebalone/portfolios/get-security-model-names').pipe(delay(1000));
    }

    getPortfolioNameDropDownValues(): Observable<any> {
        return this.http.get("/irebalone/rebalance-portfolios/portfolios-drop-down").pipe(delay(1000));
    }

    getMasterAccounts(): Observable<string[]> {
        return this.http.get<string[]>('/irebalone/accounts/get-master-acct-numbers').pipe(delay(1000));
    }

    getPfDropdown(): Observable<IAccountNameList> {
        return this.http.get<IAccountNameList>('/irebalone/accounts/pf-drop-down').pipe(delay(1000));
    }

    checkExternalAcctExists(accountNumber: string): Observable<IExternalAccountExists> {
        return this.http.post<IExternalAccountExists>(`/irebalone/accounts/external-acct-exists-active/${accountNumber}`, '').pipe(delay(1000));
    }

    createExternalAcct(data: ICreateExternalAccount): Observable<any> {
        return this.http.post<any>(`irebalone/accounts/create-external-account`, data).pipe(delay(1000));
    }

    exportSpecificAccountCashSettings(data: any):Observable<any> {
        return this.http.post('/irebalone/accounts/async/export-account-cash-settings/', data);
    }

    exportAllAccountCashSettings (SelectAll:boolean, deselectedIDs: any):Observable<any> {
        const sortParam = this._sortCriteria !== undefined ? this._sortCriteria : '';
        const filterParam = this._filterCriteria !== undefined ? this._filterCriteria : '';
        return this.http.post('/irebalone/accounts/async/export-all-account-cash-settings/?SelectAll=' + SelectAll + filterParam + '&' + sortParam, deselectedIDs);
    }

    exportAccountDetails(data: IExportRequest):Observable<any> {
        data.filter = decodeURIComponent(this._filterCriteria !== undefined ? this._filterCriteria : '');
        data.sort = decodeURIComponent( this._sortCriteria !== undefined ? this._sortCriteria : '');
        return this.http.post('/irebalone/accounts/async/export-account-details', JSON.stringify(data), this.httpOptions);
    }

    getAllAccountDetails (SelectAll:boolean, deselectedIDs: any):Observable<any> {
        return this.http.post('/irebalone/accounts/get-all-account-details/?SelectAll=' + SelectAll + this._filterCriteria + '&' + this._sortCriteria ,deselectedIDs);
    }

    saveInlineAccount(accountDetail: IAccount) {
        return this.http.post("/irebalone/accounts/edit-account", JSON.stringify(accountDetail), this.httpOptions);
    }

    getInlineAccount(accountId: number): Observable<Object> {
        return this.http.get("/irebalone/accounts/fetch-account-details/" + accountId, this.httpOptions);
    }
    
    clearCriteria(){
        this._filterCriteria = '';
        this._sortCriteria = '';
        this._filterKeys = '';
    }

    getExternalAccountsDetails(data: IExportRequest): Observable<any> {
        data.filter = decodeURIComponent(this._filterCriteria !== undefined ? this._filterCriteria : '');      
        data.sort = decodeURIComponent( this._sortCriteria !== undefined ? this._sortCriteria : ''); 
        return this.http.post('/irebalone/accounts/async/get-account-details', JSON.stringify(data), this.httpOptions);
    }

    deleteExternalAccounts(data: IExternalAccountRequest): Observable<any> {
        return this.http.post('/irebalone/accounts/delete-external-accounts', JSON.stringify(data), this.httpOptions);
    }

    confirmDeleteExternalAccounts(data: IExternalAccountRequest): Observable<any> {
        return this.http.post('/irebalone/accounts/confirm-delete-external-accounts', JSON.stringify(data), this.httpOptions);
    }

    // getCustodianDropDownValues(): Observable<ICustodianNameList> {
    //     return this.http.get<ICustodianNameList>('/irebalone/accounts/custodian-drop-down').pipe(delay(1000));
    // }


    getVisibleMasterAccounts(): Observable<Object> {
        return this.http.get('/irebalone/accounts/get-visible-master-acct-numbers');
    }
}
